import React from 'react';
import { Box } from '@material-ui/core';
import { Theme } from '@orijinworks/frontend-commons';
import { CasePlanDetailHeader } from '../CasePlanDetailHeader';
import { CasePlanDetailsSections } from '../CasePlanDetailsSections';

export function CasePlanDetailsContent({
  classes,
  cardProps,
  sections,
  isSectionsLoading,
  collapsedSections,
  onBack,
  onToggleCollapse,
  onAddWidget,
  onAddSection,
  onEditorsClick,
  onExportClick,
}) {
  return (
    <Theme>
      <Box className={classes.page} role="main" aria-label="Case Plan Details">
        <CasePlanDetailHeader
          cardProps={cardProps}
          isSectionsLoading={isSectionsLoading}
          onBack={onBack}
          onEditorsClick={onEditorsClick}
          onExportClick={onExportClick}
        />
        <CasePlanDetailsSections
          isSectionsLoading={isSectionsLoading}
          sections={sections}
          collapsedSections={collapsedSections}
          onToggleCollapse={onToggleCollapse}
          onAddWidget={onAddWidget}
          onAddSection={onAddSection}
        />
      </Box>
    </Theme>
  );
}
